import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/like",
    clipPath: "url(#clip_Like)"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00011 5L7.7226 0.894651C8.09313 0.335915 8.71897 -6.38833e-07 9.3894 -5.80222e-07L9.50667 -5.6997e-07C10.059 -5.21688e-07 10.5067 0.447715 10.5067 0.999999L10.5067 5L14.0243 5C15.4451 5 16.4128 6.43986 15.8762 7.75537L13.5829 13.3777C13.4294 13.754 13.0634 14 12.657 14L5.00011 14L5.00011 5ZM2.99995 5L0.999948 5C0.447664 5 -5.19747e-05 5.44771 -5.20229e-05 6L-5.26349e-05 13C-5.26832e-05 13.5523 0.447663 14 0.999947 14L2.99995 14L2.99995 5Z",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Like16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Like16 = createIcon(IconComponent);